// src/components/NoProjectsTransition.tsx
import React from 'react';
import { ShoppingBag, FolderPlus } from 'lucide-react';
import { useCaps } from '../contexts/CapabilitiesContext';

interface NoProjectsTransitionProps {
  onGoToMarketplace: () => void;
  onCreateProject: () => void;
}

const NoProjectsTransition: React.FC<NoProjectsTransitionProps> = ({
  onGoToMarketplace,
  onCreateProject,
}) => {
  const { can } = useCaps();
  const canCreateProject = can('projects_create');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#C3D74F]/5 via-white to-[#43C8F5]/5">
      <div className="text-center max-w-lg mx-4">
        <div className="w-20 h-20 bg-[#C3D74F]/15 rounded-full flex items-center justify-center mx-auto mb-6">
          <FolderPlus className="w-10 h-10 text-[#8B9A2B]" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Welcome to the Canvas</h1>
        <p className="text-gray-600 mb-10 text-lg">
          Where would you like to start?
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onGoToMarketplace}
            className="flex items-center justify-center gap-3 px-8 py-4 bg-white border-2 border-gray-200 rounded-xl text-gray-700 hover:border-[#43C8F5]/40 hover:bg-[#43C8F5]/5 transition-all shadow-sm hover:shadow-md"
          >
            <ShoppingBag className="w-5 h-5 text-[#43C8F5]" />
            <span className="font-semibold">Go to the Marketplace</span>
          </button>

          {canCreateProject && (
            <button
              onClick={onCreateProject}
              className="flex items-center justify-center gap-3 px-8 py-4 bg-[#C3D74F] border-2 border-[#C3D74F] rounded-xl text-[#3d4a0e] hover:bg-[#d4e66a] transition-all shadow-sm hover:shadow-md"
            >
              <FolderPlus className="w-5 h-5" />
              <span className="font-semibold">Create an Innovation</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoProjectsTransition;
